import BmoLogo from '../../../assets/BmoLogo.png';
import BokzBanner from '../../../assets/BokzBanner.png';
import CoracleLogo from '../../../assets/Coracle.png';
import ExpatrioLogo from '../../../assets/Expatrio.png';
import FlywireBanner from '../../../assets/FlywireBanner.png';
import LoansAvatarImage from '../../../assets/LoansAvatarImage.png';
import MyDormStoreBanner from '../../../assets/MyDormStoreBanner.png';
import RbcLogo from '../../../assets/RbcLogo.png';
import SOPGeneratorLogo from '../../../assets/SopGeneratorLogo.png';
import TdLogo from '../../../assets/TdLogo.png';
import UKCredibilityInterviewLogo from '../../../assets/UKCredInterviewPracticeLogo.png';
import UniversityLivingBanner from '../../../assets/UniversityLivingBanner.png';
import { getRootUrl } from '../../../common/utils/getRootUrl';
import { default as StudentLoanServiceCard } from '../../../components/ServiceCard/StudentLoanServiceCard';
import { Incentive, IncentiveServiceType } from '../../../data/incentives/useIncentives';

export const gicCardsData = (incentivesMap: Record<IncentiveServiceType, Incentive>) => [
  {
    get cardKey() {
      return `${this.service}-${this.vendor}`;
    },
    service: 'gic',
    serviceLabel: 'Financial Services',
    vendor: 'rbc',
    badge: incentivesMap['GIC']?.display_text,
    image: RbcLogo,
    isImageForAvatar: false,
    title: 'RBC International Student GIC Program',
    description: `Strengthen and streamline your study permit application with a GIC from RBC, Canada's largest bank.`,
    shareLinkButtonName: 'Share link',
    applyButtonName: 'Apply',
    vendorUrl: `${getRootUrl()}/gic/rbc/initiate`,
  },
  {
    get cardKey(): string {
      return `${this.service}-${this.vendor}`;
    },
    service: 'gic',
    serviceLabel: 'Financial Services',
    vendor: 'bmo',
    badge: incentivesMap['GIC']?.display_text ?? '',
    image: BmoLogo,
    isImageForAvatar: true,
    title: 'BMO International Student GIC Program',
    description:
      'Get exclusive access to BMO NewStart Pre-Arrival Program and get instant processing of eligible International Student Program GIC applications.',
    shareLinkButtonName: 'Share link',
    applyButtonName: 'Apply',
    vendorUrl:
      'https://www.bmo.com/main/personal/newcomers-to-canada/pre-arrival/?&ecid=ot-F25NTCPreArrivalEDB4-ODUM26&utm_medium=ApplyBoard&utm_source=BMO_SEG_DA',
  },
  {
    get cardKey() {
      return `${this.service}-${this.vendor}`;
    },
    service: 'gic',
    serviceLabel: 'Financial Services',
    vendor: 'td',
    badge: incentivesMap['GIC']?.display_text,
    image: TdLogo,
    isImageForAvatar: true,
    title: 'TD International Student GIC Program',
    description:
      'Expedite your study permit application with a verifiable GIC from TD, a top 10 North American bank.',
    shareLinkButtonName: 'Share link',
    applyButtonName: 'Apply',
    vendorUrl: `${getRootUrl()}/gic/td/initiate`,
  },
];

export const forexCardsData = () => [
  {
    get cardKey() {
      return `${this.service}-${this.vendor}`;
    },
    service: 'forex',
    serviceLabel: 'Financial Services',
    vendor: 'flywire',
    image: FlywireBanner,
    title: 'Tuition payments made easy',
    isTitleUnderImage: true,
    description: `Improve Your Study Permit Application with Verifiable Tuition Payments.`,
    shareLinkButtonName: 'Share link',
    applyButtonName: 'Pay tuition',
    vendorUrl: 'https://www.applyboard.com/flywire',
  },
];

export const loanCardsData = (incentivesMap: Record<IncentiveServiceType, Incentive>) => [
  {
    get cardKey() {
      return `${this.service}-${this.vendor}`;
    },
    service: 'loan',
    serviceLabel: 'Financial Services',
    vendor: 'student',
    badge: incentivesMap['Loan']?.display_text,
    image: LoansAvatarImage,
    title: 'ApplyBoard loan services',
    description: `Don't let a lack of funds keep you from achieving your dreams. Jumpstart your journey with ApplyBoard Student Loans.`,
    shareLinkButtonName: 'Share link',
    applyButtonName: 'Apply',
    vendorUrl: `${getRootUrl()}/loan/initiate`,
    serviceCardType: StudentLoanServiceCard,
  },
];

export const housingCardsData = () => [
  {
    get cardKey() {
      return `${this.service}-${this.vendor}`;
    },
    service: 'housing',
    serviceLabel: 'Housing',
    vendor: 'university living',
    image: UniversityLivingBanner,
    description: `Find safe, affordable housing near you school. With expert support, you can compare verified properties, get deals, and book confidently.`,
    shareLinkButtonName: 'Share link',
    applyButtonName: 'Get started',
    vendorUrl: `${getRootUrl()}/accommodations`,
  },
];

export const bankingCardsData = (incentivesMap: Record<IncentiveServiceType, Incentive>) => [
  {
    get cardKey() {
      return `${this.service}-${this.vendor}`;
    },
    service: 'banking',
    serviceLabel: 'Financial Services',
    vendor: 'bmo',
    badge: incentivesMap['Banking']?.display_text,
    image: BmoLogo,
    isImageForAvatar: true,
    title: 'Open a Canadian bank account',
    description:
      'The award-winning BMO NewStart® Program allows for instant processing of eligible pre-arrival account applications for students from a qualifying country.',
    shareLinkButtonName: 'Share link',
    applyButtonName: 'Apply',
    vendorUrl:
      'https://www.bmo.com/main/personal/newcomers-to-canada/pre-arrival/?ecid=ot-F25NTCPreArrivalEDB4-ODUM26&utm_medium=ApplyBoard&utm_source=BMO_SEG_DA',
  },
  {
    get cardKey() {
      return `${this.service}-${this.vendor}`;
    },
    service: 'banking',
    serviceLabel: 'Financial Services',
    vendor: 'expatrio',
    badge: '',
    image: ExpatrioLogo,
    isImageForAvatar: false,
    title: '',
    description:
      'Instantly get a blocked account and health insurance through Expatrio, and get a cashback bonus of €69.',
    shareLinkButtonName: 'Share link',
    applyButtonName: 'Apply',
    vendorUrl: 'https://www.expatrio.com/?p=ApplyBoard',
  },
  {
    get cardKey() {
      return `${this.service}-${this.vendor}`;
    },
    service: 'banking',
    serviceLabel: 'Financial Services',
    vendor: 'coracle',
    badge: '',
    image: CoracleLogo,
    isImageForAvatar: false,
    title: '',
    description:
      'Instantly get a blocked account with an IBAN (International Bank Account Number) and enjoy the best price on the market: a one-time cost of €59, with NO monthly fees.',
    shareLinkButtonName: 'Share link',
    applyButtonName: 'Apply',
    vendorUrl: 'https://www.coracle.de/?ref=applyboard',
  },
];

export const arrivalKitCardsData = () => [
  {
    get cardKey() {
      return `${this.service}-${this.vendor}`;
    },
    service: 'arrival_kits',
    serviceLabel: 'Arrival Kits',
    vendor: 'bokz',
    badge: 'Discounts available',
    image: BokzBanner,
    title: 'Student Essentials kits',
    description: `Get pre-arrival bundles with bedding, kitchenware, towels, and more all designed for European student housing. Delivered directly to your accommodation. Save time, stress, and money.`,
    shareLinkButtonName: 'Share link',
    applyButtonName: 'Get started',
    vendorUrl: `https://bokz.life/product/the-essential`,
  },
  {
    get cardKey() {
      return `${this.service}-${this.vendor}`;
    },
    service: 'arrival_kits',
    serviceLabel: 'Arrival Kits',
    vendor: 'mydormstore',
    badge: 'Discounts available',
    image: MyDormStoreBanner,
    title: 'Canada Starter Kits',
    description: `Bundle and save on must-have items like bedding, kitchen sets, towels, and more. Delivered right to your residence before you arrive. Just unpack and settle in.`,
    shareLinkButtonName: 'Share link',
    applyButtonName: 'Get started',
    vendorUrl: `https://mydormstore.ca/pages/applyboard`,
  },
];

export const academicToolsCardsData = () => [
  {
    get cardKey() {
      return `${this.service}-${this.vendor}`;
    },
    service: 'academic tools',
    serviceLabel: 'Academic Tools',
    vendor: 'sop generator',
    badge: undefined,
    image: SOPGeneratorLogo,
    title: 'SOP Generator',
    description:
      'Generate a professional Statement of Purpose with step-by-step AI guidance tailored to you, your program and destination.',
    shareLinkButtonName: 'Share Link',
    applyButtonName: 'Try Now',
    applyButtonCTAUrl: `${getRootUrl()}/sop-generator`,
    vendorUrl: `${getRootUrl()}/sop-generator`,
    disabled: false,
  },
  {
    get cardKey() {
      return `${this.service}-${this.vendor}`;
    },
    service: 'academic tools',
    serviceLabel: 'Academic Tools',
    vendor: 'uk credibility interview',
    badge: undefined,
    image: UKCredibilityInterviewLogo,
    title: 'UK Credibility Interview Practice',
    description:
      'Prepare for your UK credibility interview using real interview questions and instant AI feedback.',
    shareLinkButtonName: 'Share Link',
    applyButtonName: 'Try Now',
    applyButtonCTAUrl: 'https://careers.interviewer.ai/Ai/a05b1684-31e1-4d23-ac42-7bb3e0866e54',
    vendorUrl: 'https://careers.interviewer.ai/Ai/a05b1684-31e1-4d23-ac42-7bb3e0866e54',
    disabled: false,
  },
];
